/*
 * @Description: 待支付-批量列表-修改
 * @Date: 2020-12-12 17:43:20
 */

import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import { csoCustomerOrder } from '@/api/ajax';

let example = new TableRenderClass({ fields, search });

const part = example.createPart({
  name: '修改',
  search: ['orderNo', 'projectName'],
  list: csoCustomerOrder.listPayOrderByBatchOrderId,
  requestNow: true,
  fields: ['index', 'orderNo', 'projectName', 'sumPayCount', 'operation']
});

export const editPayProject = [
  {
    name: '修改',
    childMenu: [part]
  }
];
